export enum FileEntityKey {
  InvoiceId = 'invoice_id',
  UserId = 'user_id',
  TodoId = 'todo_id',
  ExpenseId = 'expense_id',
  FileId = 'file_id', // Used for all types when downloading the file.
}

export enum FileEntityKind {
  Invoice = 'invoice',
  Avatar = 'avatar',
  TodoAttachment = 'todo_attachment',
  Expense = 'expense',
}
